// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"modal-header_modalHeader__2wMn1","closeIcon":"modal-header_closeIcon__1y3bU","disabledClose":"modal-header_disabledClose__3A_-I"};